/**
 * Steps and registered callbacks for KeenCorp
 * Joyride
 *
 * Author: Daniel Waghorn
 */

import $ from 'jquery';

var waitForElementVisible = function(element, callback) {
    var checkExist = setInterval(function() {
        const $element = typeof element === "function" ? $(element()) : $(element);
        if ($element.is(':visible')) {
            clearInterval(checkExist);
            if (typeof callback === "function") {
                callback();
            }
        }
    }, 100);
};

var nextOnCallback = function(callback) {
    var currentStep = window.hopscotch.getCurrStepNum();
    callback(function() {
        window.hopscotch.startTour(window.keencorp.tour, currentStep - 1);
    });
};

export default {
  id: 'keencorp_joyride',
  steps: [
    {
      target: "div#LineChart",
      placement: "top",
      title: "Welcome to the KeenCorp dashboard!",
      content: "Follow the steps in this tour to take a test drive. Let's start with MoodMetrix.<style>.hopscotch-bubble-arrow-border,.hopscotch-bubble-arrow { display: none; }</style>",
      yOffset: 93,
    },
    {
      target: "index-number",
      placement: "right",
      content: "The top-level score gives the day-by-day status of the organization",
      yOffset: 70,
    },
    {
      target: ".rv-xy-plot__inner",
      placement: "top",
      content: "The graph plots the daily scores over time, showing trends and the impact of events",
      xOffset: 128,
      yOffset: 12,
    },
    {
      target: '#startDate',
      placement: "bottom",
      content: "Change start date and end date to zoom in and out, allowing periodic analysis.",
      onNext() {
        if (!document.getElementById('Job Family:Product Development')) {
          document.querySelector('div[title="Job Family"]').click();
        }
      },
      xOffset: 30,
    },
    {
      target: 'div[title="Diversity"]',
      placement: "right",
      content: "Bespoke clusters reflect the organization’s own priorities and areas of specific interest.",
      onPrev() {
        if (!document.getElementById('Job Family:Product Development')) {
          document.querySelector('div[title="Job Family"]').click();
        }
      },
      onNext() {
        const el = document.getElementById('checkbox:Sales And Marketing')
        if (el && !el.checked) {
          el.disabled = false;
          el.click();
          el.disabled = true;
        }
        if (window.keencorp.date_changed) return;
        let startDate = window.keencorp.dateRangePicker.state.startDate;
        const endDate = window.keencorp.dateRangePicker.state.endDate;
        startDate = startDate.clone().add(2, 'months');
        window.keencorp.dateRangePicker.submitDates({ startDate, endDate });
        window.keencorp.date_changed = true;

        nextOnCallback(function(callback) {
          waitForElementVisible(function() {
            return $('label[title="Sales And Marketing"]');
          }, callback);
        });
        return false;
      },
      xOffset: 30,
      yOffset: -20,
    },
    {
      target: 'label[title="Sales And Marketing"]',
      placement: "right",
      content: "Activating one or more cluster(s) enables comparison to 'All'",
      xOffset: 7,
      onPrev() {
        window.hopscotch.startTour(window.keencorp.tour, window.hopscotch.getCurrStepNum());
      },
    },
    {
      target: ".rv-xy-plot__inner",
      placement: "top",
      content: "<b>In this example:</b><br>The scores for Sales and Marketing visibly lag behind 'All'. There is a downward trend and the gap with 'All' grows during this period",
      xOffset: 298,
      yOffset: 150,
      // onNext() {
      //   const els = [
      //     document.getElementById('checkbox:Business Support'),
      //     document.getElementById('checkbox:Delivery'),
      //     document.getElementById('checkbox:Product Development'),
      //     document.getElementById('checkbox:Sales And Marketing'),
      //     document.getElementById('checkbox:Team Leaders'),
      //     document.getElementById('checkbox:Top Management'),
      //   ];
      //   for (let i = 0; i < els.length; i += 1) {
      //     const el = els[i];
      //     if (el && !el.checked) {
      //       setTimeout(() => {
      //         el.disabled = false;
      //         el.click();
      //         el.disabled = true;
      //       }, 500);
      //     }
      //   }
      // },
    },
    {
      target: "div#LineChart",
      placement: "bottom",
      content: "Scroll down to explore the Attitude Heatmap below.<style>.hopscotch-bubble-arrow-border,.hopscotch-bubble-arrow { display: none; }</style>",
      yOffset: -140,
    },
  //   {
  //     target: "div#attitude-heatmap",
  //     placement: "left",
  //     title: "Attitude Heatmap",
  //     content: "The summary status of several clusters at a glance",
  //     xOffset: 110,
  //     yOffset: 40,
  //   },
  //   {
  //     target: 'g[id="Job Family:Delivery"] circle#fill',
  //     placement: "right",
  //     content: "The size of the circle indicates the relative volume of this cluster",
  //     zIndex: 9999,
  //     xOffset: -25,
  //     yOffset: 250,
  //   },
  //   {
  //     target: 'g[id="Job Family:Delivery"] > g > text',
  //     placement: "left",
  //     content: "The KeenCorp Index score of the cluster",
  //     zIndex: 9999,
  //     yOffset: -9,
  //   },
  //   {
  //     target: 'g[id="Job Family:Sales And Marketing"] circle#fill',
  //     placement: "left",
  //     content: "A bright color ring identifies a significant upward or downward trend",
  //     zIndex: 9999,
  //   },
  //   {
  //     target: 'g[id="Job Family:Sales And Marketing"] > g > g > path',
  //     placement: "right",
  //     content: "The double downward arrow indicates a negative trend compared to 'All'",
  //     zIndex: 9999,
  //     yOffset: -20,
  //   },
  //   {
  //     target: 'g[id="Job Family:Sales And Marketing"] circle#fill',
  //     placement: "left",
  //     content: "<b>In this example:</b><br>The Sales and Marketing is highlighted and shows a significant downward trend. <br><br><b>Conclusion:</b><br>This team may require attention",
  //     zIndex: 9999,
  //   },
  //   {
  //     target: 'g[id="Job Family:Team Leaders"] circle#fill',
  //     placement: "left",
  //     content: "By comparison the cluster 'Team Leaders' scores relatively high (112) and there is no significant up or downward trend. <br><br><b>Conclusion:</b><br>No action required",
  //     zIndex: 9999,
  //   },
  ],
  showPrevButton: true,
  scrollTopMargin: 100,
};



// WEBPACK FOOTER //
// ./src/demo_tour.js